function isNumberString(value) {
  if (typeof value !== "string") {
    return false;
  }
  return !Number.isNaN(value) && !Number.isNaN(parseFloat(value)) && /^-?\d+\.?\d*$/.test(value);
}
export {
  isNumberString
};
